//// Accordian
(function($, window, undefined) {

  var defaults = {}
  
  function acToggle(element, settings) {
    this.element = $(element)
    this.settings = $.extend({}, defaults, settings)
    this.init()
  }

  acToggle.prototype = {
    init: function() {      
      var _this = this
      this.content = this.element.find('.js-ac-toggle-content'),
   
      //bind handlers
      this.element.on('click', function(e) {
        if (_this.element.hasClass('is-open')){
          _this.element.removeClass('is-open')
          _this.content.slideUp(200)
        } else {
          _this.element.addClass('is-open')
          _this.content.slideDown(200)
        }
      })   
    },
    
    closeAll:function(){
    },
  }

  $.fn.acToggle = function(settings) {
    return this.each(function () {
      $.data(this, 'acToggle', new acToggle(this, settings))
    })
  }

}(jQuery, window));


//// Quant selectors
(function($, window, undefined) {

  var defaults = {
    onChange: null,
  }

  function qntSel(element, settings) {
    this.element = $(element)
    this.settings = $.extend({}, defaults, settings)
    this.init()
  }

  qntSel.prototype = {
  
    init: function() {      
      var _this = this
      this.minus = this.element.find('span').first(),
      this.plus = this.element.find('span').last(),
      this.input = this.element.find('input')   
      this.min = 0
      this.max = Math.pow(10, 1000) 
      
      if(this.input.attr('min')){
        this.min = this.input.attr('min')
      }
      
      if(this.input.attr('max')){
        this.max = this.input.attr('max')
      }
      
     
      //bind handlers
      this.minus.on('click', function(e) {
        _this.updateValue('minus')
      })
      this.plus.on('click', function(e) {
        _this.updateValue('plus')
      }) 
      this.input.on('change', function(e) {
        //change hanlder
      }) 
    },
    
    updateValue:function(math){
      var a = parseInt(this.input.val()),
          p1 = a + 1,
          m1 = a - 1
                 
      if(math == 'plus' && p1 <= this.max){
        this.input.val(p1).trigger('change')
      }
      if(math == 'minus' && m1 >= this.min){
        this.input.val(m1).trigger('change')
      }
    },
    

  }

  $.fn.qntSel = function(settings) {
    return this.each(function () {
      $.data(this, 'qntSel', new qntSel(this, settings))
    })
  }

}(jQuery, window));


//// Modal
(function($, window, undefined) {

  var defaults = {}

  function wbskModal() {
    this.wrapper = $('.wbsk-ui-modal')
    this.openToggle = $('.js-wbsk-modal__open')
    this.closeToggle = $('.js-wbsk-modal__close')
    this.init()
  }

  wbskModal.prototype = {
    init: function() {      
      var _this = this
      //bind handlers
      this.openToggle.on('click', function(e) {
        e.preventDefault()
        var $target = $(e.target).attr('href')
        _this.open($target)  
      })  
      
      this.closeToggle.on('click', function(e) {
        var $target = $(e.target).attr('href')
        _this.closeAll()  
      })  
    },
    
    open:function($target){
      $($target).show()
    },
    
    closeAll:function(){
      this.wrapper.hide()
    },
  }
  
  $.fn.wbskModal = function(settings) {
    $.data(this[0], 'wbskModal', new wbskModal(this, settings))[0]
  }

}(jQuery, window));


//// Radios
(function($, window, undefined) {

  var defaults = {
    onChange: null,
  }

  function wbskRadio(element, settings) {
    this.element = $(element)
    this.settings = $.extend({}, defaults, settings)
    this.value = false
    this.init()
  }

  wbskRadio.prototype = {
    init: function() {      
      var _this = this
      
      //bind handlers
      this.element.on('click', function(e) {
        e.preventDefault()
        _this.element.toggleClass('wbskRadio--active')
        _this.value = _this.element.hasClass('wbskRadio--active')
        if (typeof _this.settings.onChange === 'function') {
          _this.settings.onChange(_this.value,_this.element.data())
        }
        
      })      
    },
  }
  
  $.fn.wbskRadio = function(settings) {
    return this.each(function () {
      $.data(this, 'wbskRadio', new wbskRadio(this, settings))
    })
  }

}(jQuery, window));

//// Mobile Menu
(function($, window, undefined) {

  var defaults = {}

  function wbskMobileMenu(element) {
    this.element = $(element)
    this.menu = $('.js-wbsk-mobile-menu')
    this.openToggle = $('.js-wbsk-mobile-menu__open')
    this.closeToggle = $('.js-wbsk-mobile-menu__close')
    this.menuChildItemToggle = $('.js-wbsk-mobile-menu__has-child')
    this.init()
  }

  wbskMobileMenu.prototype = {
    init: function() {      
      var _this = this
      
      //bind handlers
      this.openToggle.on('click', function(e) {
        e.preventDefault()
        _this.open()
      })  
      
      this.closeToggle.on('click', function(e) {
        e.preventDefault()
        _this.close()  
      })  
      
      this.menuChildItemToggle.on('click', function(e) {
        e.preventDefault()
        $(this).toggleClass('__is-open').next('ul').slideToggle(200)
      })  
    },
    
    open:function(){
      this.menu.show()
    },
    
    close:function(){
      this.menu.hide()
    },
  }
  
  $.fn.wbskMobileMenu = function(settings) {
    $.data(this[0], 'wbskMobileMenu', new wbskMobileMenu(this, settings))[0]
  }

}(jQuery, window));


////  scrollTo
(function($, window, undefined) {

  var defaults = {}

  function wbskScrollTo(element) {
    this.element = element
    this.init()
  }

  wbskScrollTo.prototype = {
    init: function() {      
      this.links = $('[data-js-wbksrollto-link]')
      this.anchors = $('[data-js-wbksrollto-anchor]')
      this.bind()
    },
    
    bind:function(){
      var _this = this
      //bind link clicks
      this.links.on('click', function(e) {
        e.preventDefault()
        var link = $(this).data('js-wbksrollto-link'),
            anchor = _this.anchors.filter(function(index,anchor){
              return $(anchor).data('js-wbksrollto-anchor') == link
            })[0]
        $('html, body').animate({
          scrollTop: $(anchor).offset().top
        }, 1000);
      })  
    }

  }
  
  $.fn.wbskScrollTo = function(settings) {
    $.data(this[0], 'wbskScrollTo', new wbskScrollTo(this, settings))[0]
  }

}(jQuery, window));

